import {Dto, DtoWithId} from "@mango/core";


@Dto({fullName: "AccessMonitor.Logic.Company"})
export class Company extends DtoWithId {
  id: number;
  name: string;
}
